// Prospect index filters
const getDefaultState = () => {
	return {
		filters: {
			query: "",
			broker_id: "",
			status: "active",
			market: "",
			trade_id: "",
			stage: "",
			// Not Algolia facets: due becomes a numeric filter on the page, view picks table or board
			due: "",
			view: "table",
			currentPage: 0,
		},
	}
}

export const state = () => getDefaultState()

export const mutations = {
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	// Replaced rather than assigned: the store is persisted, so a browser holding filters saved before
	// a key existed would otherwise gain it as a non-reactive property
	SET_FILTER(state, { filterName, value }) {
		state.filters = { ...state.filters, [filterName]: value }
	},
}

export const actions = {
	// Reset clears the filters, not the chosen view
	reset({ commit, state }) {
		const view = state.filters.view || "table"
		commit("RESET_STATE")
		commit("SET_FILTER", { filterName: "view", value: view })
	},
	updateFilter({ commit }, { filterName, value }) {
		commit("SET_FILTER", { filterName, value })
	},
}

export const getters = {
	getFilters(state) {
		return state.filters
	},
	getFilter: (state) => (filterName) => {
		return state.filters[filterName]
	},
}
